<template>
  <component
    :is="withContainer ? 'ChiftContainer' : 'div'"
    v-bind="withContainer ? { size: 'extra-small' } : {}"
  >
    <div v-if="$can('send_invoice_to_accounting') && invoice.company.chift">
      <div
        v-if="invoice.chift_id"
        class="flex gap-2 rounded px-1.5 font-semibold text-emerald-500"
      >
        <span><FontAwesomeIcon :icon="['fas', 'check-circle']" /></span>
        <span>{{ $t('global.sended') }}</span>
      </div>
      <template v-else>
        <BaseButton
          v-if="chiftSendOptions.type === 'manually'"
          theme-color="bg-secondary text-contrast-secondary"
          :title="$t('button.send_to_accounting')"
          icon="paper-plane"
          class="w-full"
          size="extra-small"
          inverse-icon-order
          :display-loader="sending"
          :disabled="sending || disabled"
          @click="sendToAccounting"
        />
        <div v-else class="flex flex-col gap-2">
          <div
            class="flex gap-2 rounded border border-dashed border-emerald-500 bg-emerald-50 px-1.5 py-0.5 font-semibold text-emerald-500"
          >
            <span><FontAwesomeIcon :icon="['fas', 'alarm-clock']" /></span>
            <span>{{
              sending_options.find(
                (sending_option) => sending_option.id === chiftSendOptions.type
              )?.name ?? chiftSendOptions.type
            }}</span>
          </div>
          <BaseButton
            theme-color="bg-secondary text-contrast-secondary"
            :title="$t('button.send_to_accounting')"
            icon="paper-plane"
            class="w-full"
            size="extra-small"
            inverse-icon-order
            :display-loader="sending"
            :disabled="sending || disabled"
            @click="sendToAccounting"
          />
        </div>
        <div v-if="invoice.chift_id">
          {{ $t('global.pending_accounting') }}
        </div>
      </template>
    </div>
  </component>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ChiftContainer from '@c/Partner/Chift/ChiftContainer.vue'

export default {
  name: 'ChiftAccountingInvoiceComponent',
  components: { ChiftContainer, FontAwesomeIcon, BaseButton },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    withContainer: {
      type: Boolean,
      default: true
    }
  },
  emits: ['success'],
  data() {
    return {
      sending: false
    }
  },
  computed: {
    ...mapGetters({
      sending_options: 'metadata/getChiftSendingOptions'
    }),
    chiftSendOptions() {
      return this.invoice.account_diary?.settings.chift.send_options
    }
  },
  methods: {
    ...mapActions({
      processSendToAccountingAction: 'invoicing/sendToAccounting'
    }),
    sendToAccounting() {
      this.sending = true
      this.processSendToAccountingAction({
        invoice_id: this.invoice.id
      })
        .then((response) => {
          if (response.success) {
            this.$h.toastSuccess(this.$t('global.sent_to_accounting'))
            this.$emit('success', true)
          } else {
            this.$h.toastDanger(response.message)
          }
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>
